import { AdvertiserCategory } from './advertiser'

export interface BrandAdvertiserConfigurationRowDTO {
  domain: string
  category: AdvertiserCategory
  // Only resolved for official domains; null when Google has no favicon for the domain.
  faviconUrl: string | null
}

export interface ReplaceBrandAdvertiserConfigurationPayload {
  brandID: string
  country: string
  officials: string[]
  competitors: string[]
  partners: string[]
  networkEntities?: string[]
  intermediaries?: string[]
  undesirables?: string[]
}

export interface UpdateAdvertiserCategoryPayload {
  brandID: string
  country: string
  domain: string
  category: AdvertiserCategory
}

// Rows come sorted by category then domain: the first official with a favicon wins.
export function getBrandFaviconUrl(rows: BrandAdvertiserConfigurationRowDTO[]): string | undefined {
  return (
    rows.find((row) => row.category === AdvertiserCategory.Official && row.faviconUrl)
      ?.faviconUrl ?? undefined
  )
}

// A 400 on the configuration routes lists the rejected domains as they were sent.
export function getInvalidDomains(error: unknown): string[] | null {
  const invalidDomains = (error as { body?: { invalidDomains?: unknown } } | null)?.body
    ?.invalidDomains
  return Array.isArray(invalidDomains) &&
    invalidDomains.every((domain) => typeof domain === 'string')
    ? invalidDomains
    : null
}
